import React from 'react';
import SingleSelectDropdown from '../SingleSelectDropdown';
import { DropdownOption } from 'components/DropdownSelect/dropdown.types';
import { UsersContextProvider, useUsersContext } from 'context/users.context';
import { getUsersName } from 'utils/formatting';
import { MultiselectDropdownProps } from '../../MultiSelectDropdown/MultiselectDropdown';

interface UpdatedBySingleSelectDropdownInterface {
  selectedUserId?: number;
  onChange: (newActivityState?: DropdownOption) => void;
  containedLabel?: boolean;
  inputProps?: Omit<MultiselectDropdownProps['inputProps'], 'sx'>;
}

const UpdatedBySingleSelectDropdownComponent = ({
  selectedUserId,
  onChange,
  containedLabel,
  inputProps,
}: UpdatedBySingleSelectDropdownInterface) => {
  const { users, getUserById } = useUsersContext();
  const options = users.map((user) => ({ name: getUsersName(user), id: user.id }));

  const user = getUserById(selectedUserId);
  const selected = user && { name: getUsersName(user), id: user.id };

  return (
    <SingleSelectDropdown
      fullWidth
      allOptions={options}
      setSelected={onChange}
      selected={selected}
      fieldLabel='Updated By'
      containedLabel={containedLabel}
      inputProps={inputProps}
    />
  );
};

const UpdatedBySingleSelectDropdown = ({
  selectedUserId,
  onChange,
  containedLabel,
  inputProps,
}: UpdatedBySingleSelectDropdownInterface) => (
  <UsersContextProvider>
    <UpdatedBySingleSelectDropdownComponent
      selectedUserId={selectedUserId}
      onChange={onChange}
      containedLabel={containedLabel}
      inputProps={inputProps}
    />
  </UsersContextProvider>
);

export default UpdatedBySingleSelectDropdown;
